import {useCallback, useRef, useState} from 'react'

// The top<0 guard keeps a sentinel still below the fold (short page) from tripping it.
export function useStuckOnScroll() {
  const [stuck, setStuck] = useState(false)
  const observerRef = useRef<IntersectionObserver | null>(null)
  const sentinelRef = useCallback((node: HTMLDivElement | null) => {
    observerRef.current?.disconnect()
    if (!node) return
    observerRef.current = new IntersectionObserver(
      ([entry]) => setStuck(!entry.isIntersecting && entry.boundingClientRect.top < 0),
      {threshold: 0}
    )
    observerRef.current.observe(node)
  }, [])
  return {sentinelRef, stuck}
}
